var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PATTERN_TILE = 12;
export function rechartsDiagonalStripeFillUrl(patternId) {
    return "url(#".concat(patternId, ")");
}
export function rechartsDiagonalStripeSwatchCss(chartColor) {
    return "repeating-linear-gradient(-45deg, ".concat(chartColor, " 0 3px, #ffffff 3px 5.5px)");
}
export function rechartsDiagonalStripePatternDefs(entries) {
    if (entries.length === 0)
        return null;
    return (_jsx("defs", { children: entries.map(function (_a) {
            var patternId = _a.patternId, chartColor = _a.chartColor;
            return (_jsxs("pattern", __assign({ id: patternId, patternUnits: "userSpaceOnUse", width: PATTERN_TILE, height: PATTERN_TILE }, { children: [_jsx("rect", { width: PATTERN_TILE, height: PATTERN_TILE, fill: chartColor }), _jsx("path", { d: "M0 12 L12 0 M6 18 L18 6 M-6 6 L6 -6", stroke: "#ffffff", strokeWidth: 2.4, strokeLinecap: "square" })] }), patternId));
        }) }, "recharts-diagonal-stripe-defs"));
}
